import { createTheme } from '@mui/material';

export const theme = createTheme({
    // palette: {
    //     primary: {
    //         white: COLOR.WHITE,
    //         black: COLOR.BLACK
    //     },
    //     secondary: {
    //         main: COLOR.PURPLEBLUE,
    //         azure: COLOR.AZURE,
    //         lightBlue: COLOR.LIGHTBLUE
    //     }
    // },
    spacing: 2,
    typography: {
        fontFamily: ['LibreFranklin', 'NotoSansCJKsc'].join(',')
    },
    components: {}
});
